import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { INavigationItem } from '@nrwl/navigation-abstract';
import { BreadCrumbService } from '@nrwl/common-lib';

export interface ITimePickerValue {
  isVisible: boolean;
  isFixed?: boolean;
}

export interface ITestInfoValue {
  isVisible: boolean;
  subText?: string;
  isActionHidden?: boolean;
}

@Component({
  selector: 'breadcrumb-actions-timepicker',
  templateUrl: './breadcrumb-actions-timepicker.component.html',
  styleUrls: ['./breadcrumb-actions-timepicker.component.scss']
})
export class BreadcrumbActionsTimepickerComponent implements OnInit, OnChanges {
  @Input() breadCrumbValues: Array<INavigationItem>;
  @Input() testInfoValue: ITestInfoValue = {
    isVisible: false,
    subText: null,
    isActionHidden: false
  };
  @Input() timePickerValue: ITimePickerValue = {
    isVisible: true,
    isFixed: false
  };
  @Input() testConfig: any;
  constructor(private breadCrumbService: BreadCrumbService) {}

  ngOnInit(): void {
    this.breadCrumbService.setBreadCrumbs(this.breadCrumbValues);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.breadCrumbValues &&
      changes.breadCrumbValues.currentValue !== changes.breadCrumbValues.previousValue
    ) {
      this.breadCrumbService.setBreadCrumbs(this.breadCrumbValues);
    }
  }
}
